import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { PAGE_TEXTS_KEYS } from '../../../../../../../constants/constant';
import { Button } from '../../../../ui/button';
import { CardContent } from '../../../../ui/card';
import InputField from '../../../../ui/customInput/input';
const Index = ({
  FORM_FIELD_SPECS,
  searchParams,
  handleSubmitOtherCustomerIdentifier,
  registerOtherCustomerIdentifier,
  otherCustomerIdentifierErrors,
  onSubmit,
  selectedSearchType,
  resetFormOnInteraction,
  formWrapperKey,
  setFormWrapperKey,
  setSearchParams,
  setOtherIdentifierValue,
}: any) => {
  const customerIdentifierSearchParam = searchParams?.[FORM_FIELD_SPECS?.otherIdentifierId?.id];
  const truncatedCustomerIdentifierSearchParam = customerIdentifierSearchParam?.substring(
    0,
    FORM_FIELD_SPECS?.otherIdentifierId?.maxLength ?? 19,
  );
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  return (
    <section className="lg:w-1/2">
      <form
        onSubmit={handleSubmitOtherCustomerIdentifier(onSubmit)}
        id="customerIdentifierForm"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmitOtherCustomerIdentifier(onSubmit)();
          }
        }}
      >
        <span className="absolute left-1/2 top-0 hidden h-[90%] w-[1px] bg-[#C6C6C6] lg:block"> </span>
        <span className="absolute inset-0 left-1/2 -ml-4 -mt-4 hidden h-8 w-8 rounded-[50%] bg-white text-center font-bold leading-[30px] text-black lg:top-1/2 lg:block">
          {Texts?.identifierOr}
        </span>
        <section className="px-10">
          <CardContent className="space-y-2">
            <div className="mb-5 flex justify-between" key={formWrapperKey?.[FORM_FIELD_SPECS?.otherIdentifierId?.id]}>
              <InputField
                items={`${Texts?.otherIdentifier}`}
                id={FORM_FIELD_SPECS?.otherIdentifierId?.id}
                htmlFor={FORM_FIELD_SPECS?.otherIdentifierId?.id}
                register={registerOtherCustomerIdentifier}
                errors={otherCustomerIdentifierErrors}
                label={Texts?.otherIdentifier}
                classname="w-full"
                rules={{
                  required: Texts?.otherIdentifierRequired,
                }}
                defaultValue={truncatedCustomerIdentifierSearchParam}
                maxLength={FORM_FIELD_SPECS?.otherIdentifierId?.maxLength}
                hideError
                onChange={() => {
                  resetFormOnInteraction();
                  setSearchParams({ ...searchParams, [FORM_FIELD_SPECS?.catalogId?.id]: '' });
                  setFormWrapperKey({
                    ...formWrapperKey,
                    [FORM_FIELD_SPECS?.catalogId?.id]: `key_${selectedSearchType}_${
                      FORM_FIELD_SPECS?.catalogId?.id
                    }_${Math.floor(Date.now())}}`,
                  });
                }}
                handlePaste={() => {
                  resetFormOnInteraction();
                  setSearchParams({ ...searchParams, [FORM_FIELD_SPECS?.catalogId?.id]: '' });
                  setFormWrapperKey({
                    ...formWrapperKey,
                    [FORM_FIELD_SPECS?.catalogId?.id]: `key_${selectedSearchType}_${
                      FORM_FIELD_SPECS?.catalogId?.id
                    }_${Math.floor(Date.now())}}`,
                  });
                }}
                setValue={setOtherIdentifierValue}
              />
              <Button className="ml-5 h-auto bg-[#002C4E] px-8 text-18 text-white" type="submit">
                <span className="text-lg font-semibold text-white">{Texts?.searchButtonText}</span>
              </Button>
            </div>
            {otherCustomerIdentifierErrors?.[FORM_FIELD_SPECS?.otherIdentifierId?.id] && (
              <p className="mt-2 text-sm text-scarletRed">
                {otherCustomerIdentifierErrors[FORM_FIELD_SPECS?.otherIdentifierId?.id]?.message}
              </p>
            )}
            <h4 className="mb-2 text-16 font-medium text-black">{Texts?.customerIdentifiers}</h4>
            <ul className="list-inside list-disc text-14 font-normal text-[#656668]">
              <li>{Texts?.creditAccountNumber}</li>
              <li>{Texts?.customerNumber}</li>
              <li>{Texts?.ebayBuyerId}</li>
            </ul>
          </CardContent>
        </section>
      </form>
    </section>
  );
};

export default Index;
